<template>
 <div id="app">
   <div class="container">
     <div class="row">
       <div class="col-sm-12 col-md-12 col-lg-6">
          <div class="card text-center">
            <div class="card-header">
             <a style="float:left"><span class="fa fa-chevron-left" aria-hidden="true"></span></a> 
              <h2 class="text-center">Stations</h2>
              <a style="float:right"><span class="fa fa-power-off" aria-hidden="true"></span></a> 
            </div>
            <div class="card-body">
              <app-channels-preview :channels="channels" @channelClicked="channelClicked"></app-channels-preview>
            </div>
            <div class="card-footer text-center">
           
            </div>
          </div>
       </div>
         <div class="col-sm-12 col-md-12 col-lg-6">
          <div class="card text-center">
             <div class="card-header">
             <a style="float:left"><span class="fa fa-chevron-left" aria-hidden="true"></span></a> 
              <h2 class="text-center">Stations</h2>
              <a style="float:right"><span class="fa fa-power-off" aria-hidden="true"></span></a> 
            </div>
            <div class="card-body">
              <app-current-channel :currentChannels="currentChannels" :activeChannel="activeChannel" v-if="this.showChannel"></app-current-channel>
            </div>
            <div class="card-footer text-center">
             <h5 class="text-center">currently playing</h5>
               <h4 class="text-center">{{ activeChannel.name }}</h4>
            </div>
          </div>
       </div>
     </div>
   </div>
  
 </div>
</template>

<script>

import Channels from './components/Channels.vue';
import ChannelsPreview from './components/ChannelsPreview.vue';
import CurrentChannel from './components/CurrentChannel.vue';


export default {
  name: 'app',
  data () {
    return {
      showChannel: false,
      channels: [
        {
          name: 'Puttin FM',
          code: '66,6',
          img: 'https://mir-s3-cdn-cf.behance.net/project_modules/max_1200/dfb16149473785.58b5fd592e4a0.jpg'
        },
        {
          name: 'Dribble FM',
          code: '101,2',
          img: 'https://thumbs.dreamstime.com/b/headphones-microphone-sound-waves-beats-concept-radio-station-logo-dj-disco-symbol-broadcasting-studio-label-customer-175429003.jpg'
        },
        {
          name: 'Doge FM',
          code: '99,4',
          img: 'https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcSN0HtaXXiyZbSlzHjwgfw2zMcM1sE8BwHTqw&usqp=CAU'
        },
        {
          name: 'Ballads FM',
          code: '87,1',
          img: 'https://i.pinimg.com/474x/d9/24/4e/d9244efa73b7607a5b976878a8790768.jpg'
        },
        {
          name: 'Maximum Fm',
          code: '142,4',
          img: 'https://i.pinimg.com/474x/d7/1b/78/d71b7857b0ca03b47bf4da1a71fb4421.jpg'
        },

      ],
      currentChannels: [],
      activeChannel: []
    }
  },
  components:{
    appChannels: Channels,
    appChannelsPreview: ChannelsPreview,
    appCurrentChannel: CurrentChannel,


  },
  methods: {
    channelClicked(index){
      this.showChannel = true;
      this.activeChannel = this.channels[index]
     if(index === 0){
               this.currentChannels = this.channels.slice(index, index + 2);

     } else {
        this.currentChannels = this.channels.slice(index - 1, index + 2);
     }
    }
  },
}
</script>

<style>
body{
  font-family: 'HelveticaNeue', Helvetica;
}
a{
  cursor:pointer;
}
h5{
  color: #edae61;
  font-weight: 600;
  font-size: 18px;
  text-transform: uppercase;
}
h4{
  color:#a2abbd;
  font-weight: 800;
  font-size: 24;
  text-transform: uppercase;

}
.container{
  background-color:#21212b;
  width:70%;
  padding: 100px;
  margin-top: 100px;
}
.row{
  margin: 0 auto;
  margin-top:100px;
  width:70%;
  

}
.card{
  border-radius: 25px;
  color: #a2abbd;
  border-color: transparent;
  margin-bottom: 50px;
  height:465px;

}
.card-header{
  border-radius: 25px 25px 0 0 !important;
  background-color: #edae61;
  color: #fff;
  
}
.card-header h2{
  display: inline-block;
  font-size: 24px;
  font-weight: bold;
}
.card-header .fa{
  font-size: 25px;
  font-weight: lighter;
  margin-top: 5px;
}
.card-body{
  background-color: #2a2a35;
      border-bottom: 1px solid #a2abbd !important; 

}
.card-footer{
    background-color: #2a2a35;
    border-radius: 0 0 25px 25px !important;
    color: #a2abbd;


}
</style>


// WEBPACK FOOTER //
// src/App.vue